import React, { useState } from 'react';
import { api, login, refreshTokenActuel } from '../lib/api.js';

/**
 * Changement de mot de passe obligatoire (première connexion d'un compte
 * importé : le mot de passe initial est la date de naissance). Rendu à la
 * place de tout contenu tant que me.doit_changer_mdp est vrai.
 */
export function ChangerMotDePasse({ me, onDone }) {
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  async function submit(e) {
    e.preventDefault();
    const f = e.target;
    const nouveau = f.nouveau.value;
    if (nouveau !== f.confirmation.value) { setError('La confirmation ne correspond pas au nouveau mot de passe.'); return; }
    if (nouveau.trim().length < 8) { setError('Le nouveau mot de passe doit compter au moins 8 caractères.'); return; }
    setBusy(true); setError('');
    const r = await api('me/mot-de-passe', {
      method: 'POST',
      body: { actuel: f.actuel.value, nouveau, refresh_token: refreshTokenActuel() },
    });
    setBusy(false);
    if (r.ok) onDone();
    else setError(r.error);
  }

  return (
    <div className="d-flex align-items-center justify-content-center min-vh-100 adlt-login-bg">
      <div className="card shadow-lg" style={{ maxWidth: 440, width: '100%' }}>
        <div className="card-body p-4">
          <h1 className="h4 mb-1" style={{ color: '#59308d' }}>Bienvenue{me?.nom ? ', ' + me.nom : ''} !</h1>
          <p className="text-muted mb-4">
            Pour protéger votre compte, choisissez maintenant un mot de passe personnel
            (au moins 8 caractères). Il remplace le mot de passe provisoire qui vous a été communiqué.
          </p>
          <form onSubmit={submit}>
            <div className="mb-3">
              <label className="form-label" htmlFor="adlt-mdp-actuel">Mot de passe actuel</label>
              <input id="adlt-mdp-actuel" name="actuel" type="password" className="form-control"
                autoComplete="current-password" required autoFocus />
            </div>
            <div className="mb-3">
              <label className="form-label" htmlFor="adlt-mdp-nouveau">Nouveau mot de passe</label>
              <input id="adlt-mdp-nouveau" name="nouveau" type="password" className="form-control"
                autoComplete="new-password" minLength="8" required />
            </div>
            <div className="mb-3">
              <label className="form-label" htmlFor="adlt-mdp-confirmation">Confirmation</label>
              <input id="adlt-mdp-confirmation" name="confirmation" type="password" className="form-control"
                autoComplete="new-password" minLength="8" required />
            </div>
            <button className="btn btn-primary w-100" disabled={busy}>{busy ? 'Enregistrement…' : 'Enregistrer mon mot de passe'}</button>
            {error && <div className="alert alert-danger mt-3 mb-0 py-2" role="alert">{error}</div>}
          </form>
        </div>
      </div>
    </div>
  );
}

/** Écran de connexion de la PWA autonome (JWT). */
export default function Login({ onLoggedIn }) {
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  async function submit(e) {
    e.preventDefault();
    setBusy(true); setError('');
    const form = e.target;
    const r = await login(form.username.value.trim(), form.password.value);
    setBusy(false);
    if (r.ok) onLoggedIn(r.me);
    else setError(r.error);
  }

  return (
    <div className="d-flex align-items-center justify-content-center min-vh-100 adlt-login-bg">
      <div className="card shadow-lg" style={{ maxWidth: 400, width: '100%' }}>
        <div className="card-body p-4">
          {(window.ADLT_CONFIG || {}).logo && (
            <div className="text-center mb-3" style={{ background: '#59308d', borderRadius: 16, padding: 16 }}>
              <img src={window.ADLT_CONFIG.logo} alt="Compagnie des Archers de la Tour" style={{ maxWidth: 180, maxHeight: 120, objectFit: 'contain' }} />
            </div>
          )}
          <h1 className="h4 text-center mb-1" style={{ color: '#59308d' }}>Archers de la Tour</h1>
          <p className="text-center text-muted mb-4">Connectez-vous avec votre compte du club</p>
          <form onSubmit={submit}>
            <div className="mb-3">
              <label className="form-label" htmlFor="adlt-user">Identifiant ou e-mail</label>
              <input id="adlt-user" name="username" className="form-control" autoComplete="username" required autoFocus />
            </div>
            <div className="mb-3">
              <label className="form-label" htmlFor="adlt-pass">Mot de passe</label>
              <input id="adlt-pass" name="password" type="password" className="form-control" autoComplete="current-password" required />
            </div>
            <button className="btn btn-primary w-100" disabled={busy}>{busy ? 'Connexion…' : 'Se connecter'}</button>
            {error && <div className="alert alert-danger mt-3 mb-0 py-2">{error}</div>}
          </form>
        </div>
      </div>
    </div>
  );
}
